<template>
  <div id="fh5co-wrapper">
    <div id="fh5co-page">
      <Header></Header>
      <div class="text-center menu-container">
        <h2 class="heading01">法人メニュー</h2>
        <div class="mt-2">
          <a class="btn menu-btn btn-border" href="https://legame.atelier-joe.jp/" title="トレーニングアプリ" target="_blank" rel="noopener noreferrer">トレーニングアプリ</a>
        </div>
        <div class="mt-2">
          <a class="btn menu-btn btn-border" href="/book" title="食事Book">食事Book</a>
        </div>
        <!-- <div class="heading-section text-center animate-box mt-2">
          <span><a class="btn btn-border btn-blue btn-large" href="https://coubic.com/legame/products#pageContent" target="_blank" rel="noopener noreferrer">480円～ 入会申し込み</a></span>
        </div> -->
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Menu',
  components: {
    Header,
    Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app-dl-container{
  padding: 20px;
  text-align: center;
}
.app-dl-container img{
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue